import React from 'react';
import { Sticky } from 'react-sticky';
import { IconCategoryBrowse } from '../IconCategoryBrowse';
import './StickyCategoryBrowse.scss';

export const StickyCategoryBrowse = (props: { isMobile?: boolean }) => {
    return (
        <Sticky>
            {({ style }) => {
                return (
                    <div
                        style={{
                            ...style,
                            zIndex: 499,
                            top: props.isMobile ? '65px' : '55px',
                        }}
                    >
                        <div className="stickyIconCategoryBrowse">
                            <IconCategoryBrowse />
                        </div>
                    </div>
                );
            }}
        </Sticky>
    );
};
